import { render, staticRenderFns } from "./income.vue?vue&type=template&id=1833481e&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=1833481e&prod&scoped=true&lang=css&"
import style1 from "./income.vue?vue&type=style&index=1&id=1833481e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833481e",
  null
  
)

export default component.exports